import { Stack, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const Container = muiStyled(Stack)(() => ({
  background: abyssColors.primary[50],
  padding: '2.4rem 1.6rem',
  gap: '1.6rem',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
}));

export const ScrollableContainer = muiStyled(Stack)(() => ({
  flex: 1,
  overflow: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  height: '100%',
  marginBottom: '3.2rem',
}));
